<template>
  <div class="authorizationList">
    <div class="authorizationBox">
      <breadcrumb class="breadcrumbPosition">
        <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>授权管理</el-breadcrumb-item>
        </el-breadcrumb>
      </breadcrumb>
      <div class="authorizationMain">
        <div class="authorizationTab">
          <ul class="textAlign ft14 tab">
            <li class="authorActive cursorPointer" @click="accreditFn(0)">全部授权</li>
            <li @click="accreditFn(1)" class="cursorPointer">签约授权</li>
            <li @click="accreditFn(2)" class="cursorPointer">被全部授权</li>
            <li @click="accreditFn(3)" class="cursorPointer">被签约授权</li>
            <router-link
              tag="span"
              to="/personal/users/authorizedHistory"
              class="addAuthorizer ft12 cursorPointer"
              v-if="type==1"
            >授权历史记录</router-link>
            <li class="addAuthorizer ft12 cursorPointer" v-if="type==0" @click="handelClickFn">添加代理人</li>
          </ul>
        </div>
        <div class="authorizationCon">
          <all-authorized v-if="ContractType==0" @errorHint="errorHintFn" ref="initFn"></all-authorized>
          <contract-authorized v-if="ContractType==1" :message="message" @getData="getTaskIdFn"></contract-authorized>
          <by-allauthorized v-if="ContractType==2" @errorHint="errorHintFn"></by-allauthorized>
          <by-contractauthorized v-if="ContractType==3"></by-contractauthorized>
        </div>
      </div>
    </div>
    <div class="popUp">
      <Dialog
        :visible="dialogVisibleht"
        :dialogTitle="'授权'"
        v-on:closeDialog="closeDialog"
        :width="'300px'"
        v-loading="requestIng"
        class="setHeadDialog"
      >
        <div slot="dialog" class="contractHt">
          <div class="hintCon textAlign ft14" v-show="noRegister&&!errorDscp">该用户未注册，不能添加！</div>
          <div class="hintCon textAlign ft14" v-show="noRealName&&!errorDscp">该用户未实名，不能被添加！</div>
          <div class="hintCon textAlign ft14" v-show="errorDscp">{{errorDscp}}</div>
          <div class="popUpConTop ft14">
            手机号/邮箱：
            <input type="text" placeholder="输入您的手机号码/邮箱 " v-model="photo">
            <span class="confirmFn fr cursorPointer" @click="addFnht">确定</span>
            <span class="hintMessage" v-if="hintMessage">您输入的格式不对</span>
          </div>
          <div class="userinfoBox textAlign ft12" v-if="autonym">
            <ul>
              <li>{{userMessage.name}}</li>
              <li>{{userMessage.account}}</li>
              <li>已实名</li>
            </ul>
          </div>
          <div class="accreditList textAlign">
            <ul>
              <li v-for="(item,index) in accreditList" :key="index">
                <input type="checkbox" :id="item.id" class="signatureItem" :data-id="item.id">
                <label :for="item.id">
                  <img :src="item.fullFilePath">
                </label>
              </li>
            </ul>
          </div>
          <div class="ft12 textAlign authHandlerBox" style="margin: 15px auto;">
            <span class="button cursorPointer" @click="cancelFn">取消</span>
            <span class="button buttonActive cursorPointer" @click="addFn">确认</span>
          </div>
        </div>
      </Dialog>
      <Dialog
        :visible="dialogVisibleP"
        :dialogTitle="'授权'"
        v-on:closeDialog="closeDialog"
        :width="'300px'"
        class="setHeadDialog"
        v-loading="requestIng"
      >
        <div slot="dialog" class="contractHt">
          <div class="hintCon textAlign ft14" v-show="noRegister&&!errorDscp">该用户未注册，不能添加！</div>
          <div class="hintCon textAlign ft14" v-show="noRealName&&!errorDscp">该用户未实名，不能被添加！</div>
          <div class="hintCon textAlign ft14" v-show="errorDscp">{{errorDscp}}</div>
          <div class="popUpConTop ft14">
            手机号/邮箱：
            <input type="text" placeholder="输入您的手机号码/邮箱 " v-model="photo">
            <span class="confirmFn fr cursorPointer" @click="addFnht">确定</span>
            <span class="hintMessage" v-if="hintMessage">您输入的格式不对</span>
          </div>
          <div class="userinfoBox textAlign ft12" v-if="autonym">
            <ul>
              <li>{{userMessage.name}}</li>
              <li>{{userMessage.account}}</li>
              <li>已实名</li>
            </ul>
          </div>
          <div class="accreditList textAlign">
            <ul>
              <li v-for="(item,index) in accreditList" :key="index">
                <input type="checkbox" :id="item.id" class="signatureItem" :data-id="item.id">
                <label :for="item.id">
                  <img :src="item.fullFilePath">
                </label>
              </li>
            </ul>
          </div>
          <div class="ft12 textAlign authHandlerBox" style="margin: 15px auto;">
            <span class="button cursorPointer" @click="cancelFn">取消</span>
            <span class="button buttonActive cursorPointer" @click="addFn">确认</span>
          </div>
        </div>
      </Dialog>
      <Dialog
        :visible="authDialogShow"
        :dialogTitle="'消息提示'"
        :width="'400px'"
        @closeDialog="closeDialog"
        class="signDialogBox"
      >
        <div class="signDialog" slot="dialog">
          <div class="authDscp">
            <p>您还没有实名认证，</p>
            <p>无法添加授权人，请去实名认证！</p>
          </div>
          <div class="authHandlerBox">
            <div class="button buttonActive cursorPointer" @click="goAuth">去认证</div>
            <div class="button cursorPointer" @click="quxiao">取消</div>
          </div>
        </div>
      </Dialog>
      <Dialog
        :visible="errorHint"
        :dialogTitle="'消息提示'"
        :width="'300px'"
        @closeDialog="closeDialogerrorHint"
        class="errorBox"
      >
        <div class="errorBoxdialog errorBoxDialogCenter" slot="dialog">
          <p>{{errorMessage}}</p>
          <div class="authHandlerBox" style="margin:0 auto;justify-content: center;">
            <div class="button buttonActive cursorPointer" @click="errorHint = false">确定</div>
          </div>
        </div>
      </Dialog>
      <Dialog
        :visible="showFailContract"
        :dialogTitle="'消息提示'"
        :width="'300px'"
        @closeDialog="showFailContract = false"
        class="errorBox"
      >
        <div class="errorBoxdialog" slot="dialog">
          <div class="defaileBox">
            <img src="../../../assets/images/authorization/authorizationfailure_icon.png">
            <span>授权失败</span>
          </div>
          <div class="authHandlerBox" style="margin:0 auto;justify-content: center;">
            <div class="button buttonActive cursorPointer" @click="showFailContract = false">确定</div>
          </div>
        </div>
      </Dialog>
      <Dialog
        :visible="successed"
        :dialogTitle="'消息提示'"
        :width="'300px'"
        @closeDialog="closeDialog"
        class="errorBox"
      >
        <div class="successBox" slot="dialog">
          <img src="../../../assets/images/authorization/authorizedsuccess_icon.png">
          <span>授权成功</span>
        </div>
      </Dialog>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import BaseApi from "@lib/baseApi.js";
import Dialog from "../../common/Dialog.vue";
import Breadcrumb from "@common/Breadcrumb.vue";
import allAuthorized from "./components/authorization/Allauthorized.vue";
import contractAuthorized from "./components/authorization/Contractauthorized.vue";
import byAllauthorized from "./components/authorization/ByAllauthorized.vue";
import byContractauthorized from "./components/authorization/byContractauthorized.vue";
export default {
  data() {
    return {
      // 是否在请求数据
      successed: false,
      requestIng: false,
      type: 0,
      contractName: "", //合同名称
      creatDate: "", //创建日期
      notification: "", //通知方式
      listsTable: [], //返回来的结果
      listsTables: [],
      autonym: false,
      errorMessage: "",
      message: "",
      dialogVisible: false,
      dialogVisibleP: false,
      errorHint: false,
      realName: false,
      noRealName: false,
      noRegister: false,
      accreditList: [],
      exhibition: true,
      dialogVisibleht: false,
      photo: "",
      id: "",
      ifx: [],
      idx: "",
      num: "",
      ContractType: 0,
      userMessage: {},
      hintMessage: false,
      listImg: [],
      checkbox: false,
      authDialogShow: false,
      contractMode: "2",
      errorDscp: "",
      // 需要展示授权失败的合同
      showFailContract: false,
      powerFaliErrString: "",
      //失败原因
      failErrorReson: ""
    };
  },
  methods: {
    accreditFn(num) {
      this.ContractType = num;
      $(".authorizationTab li").removeClass("authorActive");
      $(".authorizationTab li")
        .eq(num)
        .addClass("authorActive");
      this.type = num;
    },
    getTaskIdFn(data) {
      this.ifx = data;
    },
    closeDialog(data) {
      this.successed = data;
      this.dialogVisibleP = data;
      this.dialogVisible = data;
      this.dialogVisibleht = data;
      this.authDialogShow = data;
    },
    errorHintFn() {
      this.errorHint = true;
    },
    dialogVisiblePFn() {
      this.dialogVisibleP = true;
    },
    closeDialogerrorHint(data) {
      this.errorHint = data;
      // this.dialogVisibleht = true;
    },
    handelClick() {
      this.autonym = false;
      this.photo = "";
      this.contractMode = "1";
      let checkDoms = $(".signatureItem");
      for (var i = 0; i < checkDoms.length; i++) {
        checkDoms[i].checked = false;
      }
      if (this.checkbox != false) {
        this.ifx = [];
        if (this.multipleSelection.length != 0) {
          const loading = this.$loading({
            lock: true,
            text: "正在加载"
          });
          BaseApi.createRpcToken("/user/v2/getUserInfo").then(
            data => {
              console.log(data.datas.success);
              if (data.datas.success == false) {
                this.authDialogShow = true;
                return;
              } else {
                var queryStr = {
                  checkStatus: "2"
                };
                BaseApi.createRpcToken("/seal/sealList", queryStr)
                  .then(
                    data => {
                      this.authDialogShow = false;
                      this.dialogVisibleht = true;
                      for (var j = 0; j < this.multipleSelection.length; j++) {
                        this.ifx.push(this.multipleSelection[j].id);
                      }
                      this.accreditList = [];
                      if (data != undefined) {
                        this.accreditList = [];
                        for (var i = 0; i < data.datas.resultList.length; i++) {
                          if (data.datas.resultList[i].checkStatus == 2) {
                            this.accreditList.push(data.datas.resultList[i]);
                          }
                        }
                      }
                      loading.close();
                    },
                    data => {
                      loading.close();
                      console.log(data);
                    }
                  )
                  .catch(function(e) {
                    errorLog(e);
                  });
              }
            },
            () => {
              loading.close();
            }
          );
        }
      } else {
        this.$message.error("请选择合同");
      }
    },
    getTaskId(data, flag) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].actionCode === flag) {
          return data[i].taskId;
        }
      }
    },
    handelClickFn() {
      this.contractMode = "2";
      const loading = this.$loading({
        lock: true,
        text: "正在加载"
      });
      let checkDoms = $(".signatureItem");
      for (var i = 0; i < checkDoms.length; i++) {
        checkDoms[i].checked = false;
      }
      BaseApi.createRpcToken("/user/v2/getUserInfo").then(
        data => {
          if (data.datas.success == false) {
            this.authDialogShow = true;
            loading.close();
            return;
          } else {
            BaseApi.createRpcToken("/seal/sealList")
              .then(
                data => {
                  loading.close();
                  this.authDialogShow = false;
                  this.dialogVisibleht = true;
                  this.autonym = false;
                  this.noRegister = false;
                  this.noRealName = false;
                  this.photo = "";
                  let arry = [];
                  if (data.datas != null) {
                    this.accreditList = [];
                    for (var i = 0; i < data.datas.resultList.length; i++) {
                      if (data.datas.resultList[i].checkStatus == 2) {
                        this.accreditList.push(data.datas.resultList[i]);
                      }
                    }
                  }
                },
                data => {
                  loading.close();
                }
              )
              .catch(function(e) {
                errorLog(e);
              });
          }
        },
        () => {
          loading.close();
        }
      );
    },
    handelClickFnP() {
      console.log(this.ifx);
      this.contractMode = "1";
      const loading = this.$loading({
        lock: true,
        text: "正在加载"
      });
      let checkDoms = $(".signatureItem");
      for (var i = 0; i < checkDoms.length; i++) {
        checkDoms[i].checked = false;
      }
      BaseApi.createRpcToken("/user/v2/getUserInfo").then(
        data => {
          if (data.datas.success == false) {
            this.authDialogShow = true;
            loading.close();
            return;
          } else {
            BaseApi.createRpcToken("/seal/sealList")
              .then(
                data => {
                  loading.close();
                  this.authDialogShow = false;
                  this.dialogVisibleP = true;
                  this.autonym = false;
                  this.noRegister = false;
                  this.noRealName = false;
                  this.photo = "";
                  let arry = [];
                  if (data.datas != null) {
                    this.accreditList = [];
                    for (var i = 0; i < data.datas.resultList.length; i++) {
                      if (data.datas.resultList[i].checkStatus == 2) {
                        this.accreditList.push(data.datas.resultList[i]);
                      }
                    }
                  }
                },
                data => {
                  loading.close();
                }
              )
              .catch(function(e) {
                errorLog(e);
              });
          }
        },
        () => {
          loading.close();
        }
      );
    },
    cancelFn() {
      this.dialogVisible = false;
      this.dialogVisibleP = false;
      this.photo = "";
      this.noRealName = false;
      this.noRegister = false;
      this.dialogVisibleht = false;
    },
    addFn() {
      if (this.autonym != false) {
        if (localStorage.getItem("userName") == this.photo) {
          this.errorHint = true;
          this.dialogVisibleht = false;
          this.errorMessage = "不能添加自己为授权人";
          return;
        }
        var arry = [];
        let checkDoms = $(".signatureItem");
        for (var i = 0; i < checkDoms.length; i++) {
          if (checkDoms[i].checked) {
            arry.push(checkDoms[i].dataset.id);
          }
        }
        if (arry.length != 0) {
          var queryStr = {
            account: this.photo,
            partnerId: "1",
            contractMode: this.contractMode,
            sealMode: "1",
            sealIds: arry,
            contractIds: this.ifx
          };
          this.requestIng = true;
          BaseApi.createRpcToken("/agent/addAgent", queryStr, "post")
            .then(
              data => {
                this.requestIng = false;
                if (data.datas.code != 200) {
                  this.errorHint = true;
                  this.dialogVisibleht = false;
                  this.errorMessage = data.datas.message;
                  return;
                } else {
                  if (data.datas.fail && data.datas.fail.length) {
                    let arrEmp = [];
                    data.datas.fail.forEach(element => {
                      arrEmp.push(element.contractName);
                    });
                    this.dialogVisibleP = false;
                    this.powerFaliErrString = arrEmp.join("，");
                    this.failErrorReson = data.datas.message;
                    this.showFailContract = true;
                  } else {
                    this.dialogVisibleht = false;
                    this.dialogVisibleP = false;
                    this.showFailContract = false;
                    this.$refs.initFn.init();
                    this.successed = true;
                    // this.$message.success("授权成功");
                  }
                }

                this.dialogVisibleht = false;
                this.init();
              },
              data => {
                this.requestIng = false;
                console.log(data);
              }
            )
            .catch(function(e) {
              errorLog(e);
            });
        } else {
          this.errorDscp = "请选择印章";
          return;
        }
      } else {
        if (!this.userMessage.account) {
          this.errorDscp = "请输入授权人";
          return;
        }
      }
      this.errorDscp = "";
    },
    addFnht() {
      var emilReg = new RegExp(
        "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
      );
      var photoReg = /^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/;
      if (!emilReg.test(this.photo) && !photoReg.test(this.photo)) {
        this.hintMessage = true;
        return;
      } else {
        this.hintMessage = false;
        var queryStr = {
          account: this.photo
        };
        BaseApi.createRpcToken("/agent/queryUserInfo", queryStr)
          .then(
            data => {
              console.log(data);
              if (data.code == "200") {
                if (data.datas.code == "3020") {
                  this.noRealName = true;
                  this.noRegister = false;
                  this.autonym = false;
                }
                if (data.datas.code == "3007") {
                  this.noRegister = true;
                  this.noRealName = false;
                  this.autonym = false;
                }
                if (data.datas.code == "200") {
                  this.userMessage = data.datas;
                  console.log(this.autonym);
                  this.autonym = true;
                  this.noRealName = false;
                  this.noRegister = false;
                }
              }
            },
            data => {
              console.log(data);
            }
          )
          .catch(function(e) {
            errorLog(e);
          });
      }
    },
    goAuth() {
      //去认证页面
      this.$router.push("/personal/users/home");
    },
    quxiao() {
      this.authDialogShow = false;
    }
  },
  components: {
    Dialog: Dialog,
    Breadcrumb,
    allAuthorized,
    contractAuthorized,
    byAllauthorized,
    byContractauthorized
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.authorizationList {
  background: #eaedf1;
  width: 100%;
  box-sizing: border-box;
  .hoverStyle {
    &:hover {
      color: #e88078;
      cursor: pointer;
    }
  }
  .el-table__empty-text {
    line-height: 20px;
  }
  .authorizationBox {
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 3px;
    padding: 20px;
    box-sizing: border-box;
    overflow-y: scroll;
    .authorizationHead {
      width: 100%;
      height: 36px;
      padding: 8px 0;
      box-sizing: border-box;
      box-shadow: inset 0 -1px 0 0 rgba(230, 230, 230, 0.5);
      li {
        float: left;
      }
      li:nth-child(1) {
        display: block;
        width: 4px;
        height: 20px;
        background: #e88078;
        margin-right: 20px;
        border-radius: 4px;
      }
      li:nth-child(2) {
        color: #787878;
        font-family: "PingFangSC-Medium";
      }
    }
    .authorizationMain {
      width: 100%;
      padding-top: 30px;
      .authorizationTab {
        width: 100%;
        overflow: hidden;
        ul {
          li {
            float: left;
            border: 1px solid #e4e8eb;
            height: 36px;
            line-height: 36px;
            width: 120px;
            background: #f5f5f5;
          }
          li:nth-child(2),
          li:nth-child(3),
          li:nth-child(4) {
            border-left: 0;
          }
          .authorActive {
            border-top: 2px solid #db4437;
            height: 35px;
            line-height: 35px;
            background: #fff;
            color: #db4437;
            position: relative;
            border-bottom: 1px solid transparent;
          }
          .authorActive::before {
            position: absolute;
            left: 0;
            bottom: 0;
            content: "";
            width: 120px;
            height: 1px;
            background-color: rgba(255, 255, 255, 0);
            z-index: 1;
          }
          .seekBox {
            width: 228px;
          }
          .addAuthorizer {
            float: right;
            display: block;
            width: 88px;
            height: 30px;
            line-height: 30px;
            border: 1px solid #a5303d;
            color: #e29999;
            margin: 0;
            color: #a5303d;
            background-color: #fff;
          }
          .addAuthorizer:hover {
            background: #a5303d;
            color: #fff;
          }
          .searchBtn {
            display: block;
            width: 30px;
            height: 30px;
            background: url("../../../assets/images/warning/search_icon_nor.png");
          }
          .searchBtn:hover {
            background: url("../../../assets/images/warning/search_icon_pre.png");
          }
        }
      }
      .authorizationCon {
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
        border: 1px solid #ebeef5;
        margin-top: -1px;
      }
    }
  }
  .popUp {
    .el-dialog {
      width: 540px !important;
      overflow: hidden;
      background: #f5f5f5;
      .header {
        width: 100%;
        height: 60px;
        line-height: 60px;
        font-size: 20px;
        letter-spacing: 1px;
        .el-icon-close {
          top: 13px;
        }
      }
      .hintCon {
        width: 100%;
        height: 40px;
        line-height: 40px;
        background: #fbeceb;
        color: #D81212;
        font-family: PingFangSC-Medium;
      }
      .popUpConTop {
        padding: 0 20px;
        height: 36px;
        line-height: 36px;
        color: #646464;
        margin: 30px 0;
        position: relative;
        input {
          width: 277px;
          height: 100%;
          border: 1px solid #e4e8eb;
          text-indent: 10px;
          margin-left: 10px;
        }
        .hintMessage {
          position: absolute;
          font-size: 12px;
          color: #a5303d;
          bottom: -36px;
          left: 118px;
        }
        .confirmFn {
          display: inline-block;
          width: 100px;
          height: 100%;
          text-align: center;
          border: 1px solid #db4437;
          color: #db4437;
        }
        .confirmFn:hover {
          color: #fff;
          background: #a5303d;
          border: 1px solid #a5303d;
        }
      }
      .userinfoBox {
        width: 100%;
        height: 40px;
        box-sizing: border-box;
        padding: 0 20px;
        margin-bottom: 20px;
        li {
          float: left;
          height: 40px;
          line-height: 40px;
          background: #ffffff;
          border: 1px solid #f0f0f0;
          color: #969696;
          text-align: center;
        }
        li:nth-child(1) {
          width: calc((100% - 116px) / 2);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        li:nth-child(2) {
          width: calc((100% - 108px) / 2);
          border-left: 0;
          border-right: 0;
        }
        li:nth-child(3) {
          width: 108px;
          color: #28bf15;
        }
      }
      .accreditList {
        width: 499px;
        margin-left: 20px;
        max-height: 292px;
        overflow-y: auto;
        background: #f5f5f5;
        box-sizing: border-box;
        border-radius: 5px;
        border: 1px solid #f0f0f0;
        ul {
          background-color: #fff;
          padding-top: 3px;
          overflow: hidden;
          li {
            float: left;
            width: 161px;
            height: 113px;
            line-height: 113px;
            margin: 15px 0;
            input {
              float: left;
              line-height: 113px;
              vertical-align: middle;
              margin: 50px 10px;
              width: 12px;
              height: 12px;
            }
            input[type="checkbox"]:checked:before {
              color: red;
            }
            label {
              float: left;
              width: 113px;
              height: 113px;
              border: 1px solid #c8c8c8;
              box-sizing: border-box;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
      .accreditSq {
        width: 100%;
        height: 316px;
        margin-left: 0;
        background: #ffffff;
        box-sizing: border-box;
        padding: 0 45px;
        padding-bottom: 20px;
        overflow-y: auto;
        ul {
          li {
            float: left;
            width: 113px;
            height: 113px;
            border: 1px solid #c8c8c8;
            margin-right: 44px !important;
            margin-top: 30px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          li:nth-child(3n) {
            margin-right: 0 !important;
          }
        }
      }
      .accreditList::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }
      .accreditList::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.05);
        border-radius: 10px;
        box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
      }
      .accreditList:hover::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
      }
      .accreditList::-webkit-scrollbar-thumb:hover {
        background-color: rgba(0, 0, 0, 0.4);
        box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
      }
      .accreditList::-webkit-scrollbar-track {
        border-radius: 10px;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
        background-color: white;
      }
      .accreditSq::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }
      .accreditSq::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.05);
        border-radius: 10px;
        box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
      }
      .accreditSq:hover::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
      }
      .accreditSq::-webkit-scrollbar-thumb:hover {
        background-color: rgba(0, 0, 0, 0.4);
        box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
      }
      .accreditSq::-webkit-scrollbar-track {
        border-radius: 10px;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
        background-color: white;
      }
      .popUpConBottom {
        width: 100%;
        padding: 24px 0;
        span {
          display: inline-block;
          width: 100px;
          height: 32px;
          line-height: 32px;
        }
        span:nth-child(1) {
          color: #fff;
          margin-right: 40px;
        }
        span:nth-child(1):hover {
          background: #D81212;
        }
        span:nth-child(2) {
          background: #fff;
          color: #db4437;
          border: 1px solid #db4437;
          box-sizing: border-box;
        }
        span:nth-child(2):hover {
          border: 1px solid #D81212;
          color: #fff;
          background: #D81212;
        }
      }
    }
    .setHeadDialog {
      .header {
        width: 100%;
        height: 60px;
        line-height: 60px;
        font-size: 20px;
        letter-spacing: 1px;
        .el-icon-close {
          top: 20px;
        }
      }
    }
    .el-dialog__wrapper:nth-child(2) {
      .el-dialog {
        height: auto !important;
        .accreditList {
          background: #ffffff;
          border: 0;
          li {
            margin-right: 3px;
          }
          li:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }
    .signDialogBox {
      .el-dialog {
        width: 400px !important;
        .header {
          height: 40px;
          line-height: 40px;
          font-size: 16px;
        }
      }
      .signDialog {
        height: 200px;
        width: 400px;
        box-sizing: border-box;
        background-color: white;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        padding: 0 20px;
        .authDscp {
          font-size: 14px;
          color: #646464;
          letter-spacing: 0;
          text-align: center;
          line-height: 20px;
          padding-top: 20px;
        }
        .withInput {
          width: 100%;
          text-align: left;
          .el-input__inner {
            width: 100%;
            height: 32px;
            line-height: 32px;
          }
        }
      }
    }
  }
  .errorBox {
    .el-dialog {
      width: 400px !important;
    }
    .header {
      height: 45px !important;
      line-height: 45px !important;
      font-size: 18px !important;
    }
    .errorBoxdialog {
      height: 200px;
      overflow: hidden;
      padding: 0 15px;
      text-align: center;
      box-sizing: border-box;
      display: flex;
      width: 100%;
      flex-direction: column;
      align-items: center;
      font-size: 16px;
      padding-top: 20px;
      .defaileBox {
        height: 120px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        img {
          width: 30px;
          margin-bottom: 10px;
        }
      }
      .contentShow {
        width: 100%;
        text-align: left;
        word-break: break-all;
        word-wrap: break-word;
      }
    }
    .errorBoxDialogCenter {
      justify-content: space-around;
      align-items: center;
    }
    .successBox {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: 200px;
      background-color: #fff;
      span {
        font-size: 18px;
        color: #646464;
        margin-top: 10px;
      }
    }
  }
}
</style>
